import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { AdditionalServices } from 'src/features/parkingManagement/types/additionalServices';
import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: number;
    is_enabled?: boolean;
}

const RESOURCE = '/parkings/:parkingId/additional-service/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<AdditionalServices> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAdditionalService };
